import { Container, HStack, Image, Text, VStack } from '@chakra-ui/react';
import { InferProps } from 'prop-types';
import React, { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FwSegment } from 'components/base';
import logoFastercom from 'components/footer/logo-fastercom.png';
import { readSettings } from 'core/utils/storage';

const FwFooter: FC<Props> = () => {
  const { t } = useTranslation();

  const settings = useMemo(() => {
    return readSettings();
  }, []);

  const text = 'Powered by';

  const textStyle = {
    fontSize: 'xs',
  };

  return (
    <FwSegment as={'footer'} basic frosted>
      <Container
        as={VStack}
        spacing="2px"
        sx={{ '@media print': { display: 'none' } }}
      >
        <HStack>
          <Text {...textStyle}>{t(`glossary|${text}`)}</Text>
          <a href={settings.localMode ? '' : 'https://fasteroptim.com'}>
            <Image src={logoFastercom} height="20px" />
          </a>
        </HStack>
        <Text {...textStyle}>
          &copy; {new Date().getFullYear()} (v0.6.9-01) - Fastercom
        </Text>
      </Container>
    </FwSegment>
  );
};

const propTypes = {};

export type Props = InferProps<typeof propTypes>;

FwFooter.propTypes = propTypes;

export default FwFooter;
